import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import MapeGateChart from './mape-gate-chart'; // api

import { getMapeIttByWeek } from '../../api/mapeAPI'; // redux

import { setGateToAndFroId, setGateToAndFroMapeByWeek } from '../../redux/setting-mape';
var t = i18n.getFixedT(null, 'setting-mape');
var MapeGate = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$mape = _useSelector.mape,
      dateRange = _useSelector$mape.dateRange,
      gateToAndFroList = _useSelector$mape.gateToAndFroList,
      gateToAndFroId = _useSelector$mape.gateToAndFroId,
      gateToAndFroMapeData = _useSelector$mape.gateToAndFroMapeData,
      gateToAndFroMapeTotal = _useSelector$mape.gateToAndFroMapeTotal,
      vehicleVolumes = _useSelector$mape.vehicleVolumes;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      gateToGateMapeData = _useState2[0],
      setGateToGateData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDetailData = _useState4[0],
      setOpenDetailData = _useState4[1]; // const [ vehicleVolumesData, setVehicleVolumesData ] = useState([])


  var isMounted = useRef();
  var id = props.id,
      predictionType = props.predictionType;

  var handleDropDownChange = function handleDropDownChange(val) {
    dispatch(setGateToAndFroId(val));
  };

  useEffect(function () {
    if (!isMounted.current) return;
    var oriId = '',
        dstId = '';

    if (!_.isEmpty(gateToAndFroId)) {
      var gateIdAry = gateToAndFroId.split('-');
      oriId = gateIdAry[0];
      dstId = gateIdAry[1];
    }

    getMapeIttByWeek(contextRoot, false, dateRange, predictionType, oriId, dstId).then(function (result) {
      var mapeGateByWeek = _.cloneDeep(result.content).sort(function (a, b) {
        return a.day - b.day;
      });

      mapeGateByWeek.unshift(mapeGateByWeek.pop());
      dispatch(setGateToAndFroMapeByWeek(mapeGateByWeek));
    });
  }, [gateToAndFroId]);
  useEffect(function () {
    if (gateToAndFroList.length === 0) return;

    var newData = _.cloneDeep(gateToAndFroList);

    _.map(gateToAndFroMapeData, function (el) {
      var item = _.find(newData, function (o) {
        var gateIdAry = o.value.split('-');
        return gateIdAry[0] === el.oriGateId && gateIdAry[1] === el.dstGateId;
      });

      if (!_.isEmpty(item)) item.mape = Math.round(el.mape * 100 * 10) / 10;
    });

    setGateToGateData(newData);
  }, [JSON.stringify(gateToAndFroMapeData), JSON.stringify(gateToAndFroList)]); // useEffect(() => {
  //     if(gateToAndFroList.length === 0)
  //         return
  //     let newData = _.cloneDeep(gateToAndFroList)
  //     _.map(vehicleVolumes, el => {
  //         let item = _.find(newData, o => {
  //             let gateIdAry = o.value.split('-')
  //             return gateIdAry[0] === el.oriGateId && gateIdAry[1] === el.dstGateId 
  //         })
  //         if(!_.isEmpty(item))
  //             item.avgVehicleVolumes = el.avgVehicleVolumes
  //     })
  //     setVehicleVolumesData(newData)
  // }, [JSON.stringify(vehicleVolumes), JSON.stringify(gateToAndFroList)])

  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    }

    return function () {
      setGateToGateData([]);
      setOpenDetailData(false); // setVehicleVolumesData([])
    };
  }, []);
  if (!isMounted.current) return null;
  var fieldsLeft = {};

  _.set(fieldsLeft, 'text', {
    label: t('lbl-model')
  });

  _.set(fieldsLeft, 'mape', {
    label: t('lbl-mape'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("span", {
        className: parseInt(val) > 20 ? 'high' : ''
      }, val ? val + '%' : '');
    }
  });

  var fieldRight = {};

  _.set(fieldRight, 'text', {
    label: t('lbl-model')
  });

  _.set(fieldRight, 'avgVehicleVolumes', {
    label: t('lbl-car-count')
  });

  var totalMAPE = Math.round(gateToAndFroMapeTotal * 100 * 10) / 10;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "mape-card-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-gate-time-model')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-gate-toandfro'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-gate-toandfro'),
    list: gateToAndFroList,
    value: gateToAndFroId,
    onChange: function onChange(val) {
      return handleDropDownChange(val);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "itt-mape"
  }, /*#__PURE__*/React.createElement("div", {
    className: "itt-mape-total"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mape"
  }, "MAPE:", /*#__PURE__*/React.createElement("span", {
    className: parseInt(totalMAPE) > 20 ? 'high' : ''
  }, parseInt(gateToAndFroMapeTotal) === -1 ? t('lbl-no-data') : "".concat(totalMAPE, "%"))), /*#__PURE__*/React.createElement("span", {
    title: t('lbl-detail'),
    onClick: function onClick() {
      return setOpenDetailData(!openDetailData);
    }
  }, openDetailData ? /*#__PURE__*/React.createElement(ArrowDropDownIcon, null) : /*#__PURE__*/React.createElement(ArrowRightIcon, null))), openDetailData && /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fieldsLeft,
    data: gateToGateMapeData
  }))), /*#__PURE__*/React.createElement(MapeGateChart, null)));
});
MapeGate.defaultProps = {
  id: 'g-mape-gate'
};
MapeGate.PropTypes = {
  id: PropTypes.string
};
export default MapeGate;